import React from 'react';
import { createRoot } from 'react-dom/client'
import {BrowserRouter} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './resources/style.purged.scss';
import Routing from './components/Routing';
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import LoadingIndicator from "./components/common/LoadingIndicator";
import {persistor, store} from "./store";
import {ApolloProvider} from "@apollo/client";
import {client} from "./apollo";

const root = createRoot(document.getElementById('root'));

root.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <PersistGate loading={<LoadingIndicator/>} persistor={persistor}>
                <BrowserRouter>
                    <Routing/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </ApolloProvider>
);
